// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__-DPYo","content":"popup_content__rCCsi","active":"popup_active__DciEC","closeWrapper":"popup_closeWrapper__iJUkt","closeContainer":"popup_closeContainer__IcUKc"};